import scrollTo from "../../07-libs/scrollToElement.js";

function faqPaginationScroll() {
  // Get the faq Elements on the page
  const faqElements = document.querySelectorAll(".tx-goldgas-faq");
  // Exit if there are no faq elements on the page
  if (!faqElements) return;

  // Loop through each faq element
  faqElements.forEach((faqElement) => {
    listenForPaginationChange(faqElement);
  });

  function listenForPaginationChange(element) {
    const pagination = element.querySelector(".faq__pagination");
    if (!pagination) return;
    pagination.addEventListener("click", (event) => {
      let target = event.target;
      while (
        !target.classList.contains("pagination__arrow") &&
        !target.classList.contains("pagination__item")
      ) {
        // Exit if the target is the container
        if (target === pagination) return;
        target = target.parentNode;
      }
      // Set the offset to make sure the complete faq element is visible
      const offset = -150;
      scrollTo(element, offset);
    });
  }
}

export default faqPaginationScroll;
